/**
 * IMPORTANT!!
 *
 * DO NOT EDIT THIS FILE DIRECTLY. The relevant values are generated at build time by CRA
 * based on the .env file and the REACT_APP_* variables defined there.
 * If you need to change any of these values, please edit the .env file and rebuild the project.
 */

export const API_ENDPOINT =
  process.env.REACT_APP_SYSTEM_API_URL || "http://localhost:8080";

export const COGNITO_USER_POOL_ID =
  process.env.REACT_APP_SYSTEM_USER_POOL_ID || "";

export const COGNITO_USER_POOL_CLIENT_ID =
  process.env.REACT_APP_SYSTEM_USER_POOL_CLIENT_ID || "";

export const AWS_REGION =
  process.env.REACT_APP_SYSTEM_AWS_REGION || "eu-central-1";
